// Mock data for SynchronicTech
// Palette unchanged. Portfolio covers are local branded SVGs in /public/covers.

export const services = [
  {
    id: 1,
    slug: "web-development",
    title: "Web Development",
    icon: "Code",
    description: "Custom web applications tailored to your business — modern, scalable, and fast.",
    features: ["React & Next.js", "API Integration", "Responsive Design", "Performance Optimization"]
  },
  {
    id: 2,
    slug: "data-analytics",
    title: "Data Analytics",
    icon: "BarChart3",
    description: "Turn raw data into decisions with business intelligence and clear visualization.",
    features: ["Business Intelligence", "Predictive Analytics", "Data Visualization", "Custom Dashboards"]
  },
  {
    id: 3,
    slug: "automation",
    title: "Automation",
    icon: "Workflow",
    description: "Streamline operations with intelligent workflows, AI reporting, and data pipelines.",
    features: ["Workflow Automation", "AI-Powered Reporting", "Data Pipelines", "Process Optimization"]
  }
];

// The pipeline is a real sequence, so it earns numbered structure.
export const pipeline = [
  { step: "01", label: "Raw Data", note: "Sources, events, and signals collected in one place." },
  { step: "02", label: "Insights", note: "Modeled, visualized, and made decision-ready." },
  { step: "03", label: "Automation", note: "Repetitive work handed to reliable workflows." },
  { step: "04", label: "Growth", note: "Faster decisions compound into measurable gains." }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "E-Commerce Analytics Platform",
    category: "Data Analytics",
    year: "2025",
    description: "Real-time analytics dashboard for online retail, tracking customer behavior and sales metrics.",
    image: "/images/dashboard-illustration.png",
    technologies: ["Python", "React", "MongoDB", "TensorFlow"],
    results: "45% increase in conversion rate"
  },
  {
    id: 2,
    title: "Cloud Data Infrastructure",
    category: "Automation",
    year: "2025",
    description: "Automated cloud migration and data pipeline orchestration for a high-traffic enterprise platform.",
    image: "/images/data-center.jpg",
    technologies: ["FastAPI", "PostgreSQL", "Docker", "Kubernetes"],
    results: "60% reduction in manual tasks"
  },
  {
    id: 3,
    title: "Fintech Advisory Platform",
    category: "Web Development",
    year: "2024",
    description: "Digital advisory platform with automated portfolio insights and client-facing planning tools.",
    image: "/images/fintech-illustration.png",
    technologies: ["Node.js", "React", "WebSocket", "Redis"],
    results: "3× faster client onboarding"
  },
  {
    id: 4,
    title: "Financial Dashboard",
    category: "Web Development",
    year: "2024",
    description: "Comprehensive financial management platform with real-time market data integration.",
    image: "/images/growth-chart.jpg",
    technologies: ["React", "D3.js", "WebSocket", "AWS"],
    results: "Real-time data insights"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    priceUSD: 2500,
    period: "one-time",
    description: "Perfect for small businesses getting started",
    features: [
      "Basic website development",
      "Responsive design",
      "Contact form integration",
      "3 months support",
      "Basic SEO optimization"
    ],
    highlighted: false
  },
  {
    id: 2,
    name: "Professional",
    priceUSD: 5000,
    period: "one-time",
    description: "Ideal for growing businesses",
    features: [
      "Custom web application",
      "Data analytics dashboard",
      "API integration",
      "6 months support",
      "Advanced SEO & analytics",
      "Basic automation features"
    ],
    highlighted: true
  },
  {
    id: 3,
    name: "Enterprise",
    priceUSD: null,
    period: "pricing",
    description: "For organizations with complex needs",
    features: [
      "Full-stack development",
      "Advanced analytics & AI",
      "Complete automation suite",
      "12 months support",
      "Dedicated team",
      "Custom integrations",
      "Priority support 24/7"
    ],
    highlighted: false
  }
];

export const analyticsData = [
  { month: 'Jan', revenue: 4000, users: 2400, engagement: 2400 },
  { month: 'Feb', revenue: 3000, users: 1398, engagement: 2210 },
  { month: 'Mar', revenue: 2000, users: 9800, engagement: 2290 },
  { month: 'Apr', revenue: 2780, users: 3908, engagement: 2000 },
  { month: 'May', revenue: 1890, users: 4800, engagement: 2181 },
  { month: 'Jun', revenue: 2390, users: 3800, engagement: 2500 },
  { month: 'Jul', revenue: 3490, users: 4300, engagement: 2100 },
];

export const stats = [
  { label: "Projects Completed", value: "150+", icon: "CheckCircle" },
  { label: "Happy Clients", value: "80+", icon: "Users" },
  { label: "Years Experience", value: "5+", icon: "Award" },
  { label: "Success Rate", value: "98%", icon: "TrendingUp" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CEO, TechCorp",
    content: "SynchronicTech transformed our data infrastructure. Their analytics solutions helped us increase efficiency by 40%.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "CTO, InnovateLabs",
    content: "Outstanding work on our automation project. The team's expertise in AI and data pipelines is truly impressive.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Director, DataFlow Inc",
    content: "Professional, responsive, and results-driven. Their chatbot solution revolutionized our customer support.",
    rating: 5
  }
];

export const companyInfo = {
  name: "SynchronicTech",
  tagline: "Bridging Technology & Intelligence",
  mission: "We bridge web technology and data intelligence to help organizations make smarter decisions and deliver better customer experiences.",
  about: "SynchronicTech helps businesses transform data into actionable insights and build modern digital experiences that drive growth.",
  email: "support@synchronictech.info",
  website: "https://synchronictech.com",
  social: {
    linkedin: "#",
    twitter: "#",
    github: "#"
  }
};
